/**
 * Date を <input type="date"> の value/min 用のローカル日付文字列 (YYYY-MM-DD) に変換する。
 * 利用者のカレンダー上の「その日」を基準にするため UTC ではなくローカルの年月日を用いる。
 */
export function toDateInputValue(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
